import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M17.7511 3h3.0667l-6.6999 7.6578L22 21.0781h-6.1718l-4.8336-6.32-5.531 6.32H2.395l7.1662-8.1908L2 3h6.328l4.3695 5.7766L17.7511 3zm-1.0764 16.2424h1.6994L7.4048 4.7394H5.5814l11.0933 14.503z"
  }],
  circles: []
};
var XIcon = function XIcon(props) {
  return renderIcon(props, iconType);
};
export { XIcon };